const defaultFeedback = {
    loadSuccess(_result, _defaultMessage) {
    },
    loadFailed(_error, _defaultMessage) {
    },
    submitSuccess(_result, _defaultMessage) {
    },
    submitFailed(_error, _defaultMessage) {
    },
};
export default defaultFeedback;
